// Stream button click handler
const streamBtn = document.querySelector('.stream-text-btn');
if (streamBtn) {
    streamBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/pages/stream';
    });
}

// Shop button click handler
const shopBtn = document.querySelector('.shop-text-btn');
if (shopBtn) {
    shopBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/pages/shop';
    });
}

// Tour button click handler
const tourBtn = document.querySelector('.tour-text-btn');
if (tourBtn) {
    tourBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/pages/tour';
    });
}

// About button click handler
const aboutBtn = document.querySelector('.about-text-btn');
if (aboutBtn) {
    aboutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/pages/about';
    });
}

// Home button click handler
const homeBtn = document.querySelector('.home-text-btn');
if (homeBtn) {
    homeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/';
    });
}

console.log('BLP KOSHER shop page loaded');
